import EnrollmentApp from '../../internal-owned/portal-enrollment-v2/App';

export function PortalEnrollmentPage() {
  return (
    <main
      data-testid="parent-portal-enrollment"
      data-extracted-from="owned:ystnj/parent-portal/enrollment"
      className="w-full"
    >
      <EnrollmentApp />
    </main>
  );
}
